import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 10
  },
  section: {
    marginLeft: 10,
    marginRight: 10,
    marginTop: 7,
    marginBottom: 7
  },
  seatSection: {
    marginLeft: 10,
    marginRight: 10,
    marginTop: 7,
    marginBottom: 7
  },
  row: {
    display: "flex",
    flexDirection: "row"
  },
  column: {
    width: "50%",
    fontSize: 11,
    paddingBottom: 5
  },
  seatRow: {
    flex: 1,
    justifyContent: "space-between",
    flexDirection: "row",
    marginBottom: 10
  },
  seatColumn: {
    fontSize: 10,
    padding: 4,
    border: 1
  },
  watermark: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transform: [{ rotate: '45deg'}]
  },
  watermarkText: {
    color: "#ddd",
    opacity: 0.8,
    fontSize: 180
  }
});

class SeatPlan extends Component {
  render() {
    const { sheetPlanData, fromData } = this.props

    return (
      <Document
        author="Manish Baral"
        creator="Manish Baral"
      >
        {
          sheetPlanData.map((a, i) => {
            return (
              <Page style={styles.page} key={i}>
                <View style={styles.watermark}>
                  <Text style={styles.watermarkText}>DRAFT</Text>
                </View>
                <View style={styles.section}>
                  <View style={styles.row}>
                    <View style={styles.column}>
                      <Text>Date: { fromData.date }</Text>
                    </View>
                    <View style={styles.column}>
                      <Text>Exam Center: { fromData.examCenter }</Text>
                    </View>
                  </View>

                  <View style={styles.row}>
                    <View style={styles.column}>
                      <Text>Level: { fromData.level }</Text>
                    </View>
                    <View style={styles.column}>
                      <Text>Room No: { a.roomName }</Text>
                    </View>
                  </View>

                  <View style={styles.row}>
                    <View style={styles.column}>
                      <Text>Programme: { fromData.program }</Text>
                    </View>
                    <View style={styles.column}>
                      <Text>Year/Semester: { fromData.semester }</Text>
                    </View>
                  </View>

                  <View style={styles.row}>
                    <View style={styles.column}>
                      <Text>Subject:  { fromData.subject }</Text>
                    </View>
                    <View style={styles.column}>
                      <Text>Time: { fromData.time }</Text>
                    </View>
                  </View>

                  <View style={styles.row}>
                    <View style={styles.column}>
                      <Text>Subject Code No.: { fromData.subjectCode }</Text>
                    </View>
                    <View style={styles.column}>
                      <Text>Duration: { fromData.duration }</Text>
                    </View>
                  </View>
                </View>
                
                <View style={styles.seatSection}>
                  {
                    a.students.map((r, i) => {
                      return (
                        <View style={styles.seatRow} key={i}>
                          {
                            r.map(s => {
                              return (
                                <View style={styles.seatColumn} key={s.examRollNumber}>
                                  <Text>{ s.examRollNumber }</Text>
                                </View>
                              )
                            })
                          }
                        </View>
                      )
                    })
                  }
                </View>
              </Page>
            )
          })
        }
      </Document>
    )
  }
}

SeatPlan.propTypes = {
  sheetPlanData: PropTypes.array,
  fromData: PropTypes.object
}

export default SeatPlan
